import { render, staticRenderFns } from "./update-results.vue?vue&type=template&id=d57bae3c"
import script from "./update-results.vue?vue&type=script&lang=js"
export * from "./update-results.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports